import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../../../6729.css";

import image1 from "../../../images/gear/gera-oil/8615/8615_1front.webp";
import image2 from "../../../images/gear/gera-oil/8615/8615_1back.webp";



const images = [
  { src: image1, alt: "Front" },
  { src: image2, alt: "Back" },

];

const packageSlides = [
  { images: [image1, image2] },
 

];

const TDS_URL = "https://www.fanfaro.de/create-pdf/85";


const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF8615_-_FANFARO 8615 ATF VI_(SK).pdf" }
];





export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
   <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* LEFT IMAGE CAROUSEL */}
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://www.amazon.in/FANFARO-Synthetic-Automatic-Transmission-Germany/dp/B07N7K85JH/ref=sr_1_1?"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO ATF VI 8615</h2>

        <p>
         A universal all-season synthetic transmission fluid (ATF) for automatic gearboxes, hydraulic converters, hydraulic power steering systems, car hydraulic clutches and other hydraulic devices, including the ones operating in heavy-duty conditions in trucks and off-road vehicles. It ensures a flawless operation of an automatic gearbox, guarantees minimal wear, a lasting service life of transmissions and fuel economy. It was developed on the basis of the requirements set by GM and Ford groups.

        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
       <li>The highest-quality low-viscosity synthetic base with a consistent high viscosity index in combination with a multifunctional additive package preserves all its properties in a wide range of temperatures: it ensures good lubricating properties at low (-45 °C and lower) temperatures in winter and ensures a stable oil film under extreme loads and at high temperatures in summer;</li>

  <li>The high-technology combination of additives ensures excellent antifriction properties for gear couplings and superior friction properties for friction elements thus ensuring a significant fuel economy, a continuous, exact and smooth transmission shift in any driving conditions and an extended service life of the automatic gearbox itself and all transmission elements. It ensures a coordinated and smooth operation of clutches. It prevents scuffing;</li>

  <li>It has an exceptional thermal-oxidative and chemical stability and resistance to the high-temperature thermal degradation throughout the entire service life. It allows reducing lacquering, formation of sludge, soot and other carbon deposits, increasing the time between oil changes and ensuring the durability of transmission components thus reducing the equipment maintenance costs;</li>

  <li>It effectively protects metal parts from ferrous and non-ferrous alloys (especially radiators) from corrosion when both in and not in operation; It has a great compatibility with friction coupling materials;</li>

  <li>It effectively resists aeration and foam formation;</li>

  <li>It ensures an excellent compatibility with all sealing materials, prevents them from swelling, hardening and shrinking that allows reducing the costs for spare parts and prevents leakages. It effectively protects fluoroelastomer seals of heavy equipment;</li>

  <li>It reduces noise.</li>
        </ul> <br />

        <p>
    It is recommended for automatic gearboxes of passenger cars requiring the ATF Type Dexron-VI or Dexron-III H/G/F or Dexron-III E or FORD MERCON LV quality oil. It is recommended for use in new 6-speed transmissions of GM, BMW, Land Rover, Jaguar vehicles, as well as 8- and 10-speed transmissions of Aisin vehicles. <br />

       Colour: red. <br />
       Comply with the manufacturer’s instructions provided in the user’s manual!
        </p>


        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>JASO M315, Class 1-A-LV</li>
              
            </ul>
          </div>


          <div>
            <b>Recommendation</b>
      <ul style={{ paddingLeft: "20px" }}>
  <li>SAAB ATF HP</li>
  <li>GM Type A Suffix A</li>
  <li>SAAB JWS 3309</li>
  <li>GM Saturn T-IV Fluid</li>
  <li>ALLISON C4</li>
  <li>SAAB 93 160 393</li>
  <li>GM Saturn 22689186</li>
  <li>FCA ATF+4</li>
  <li>SAAB 93 165 147</li>
  <li>GM ATF Z1</li>
  <li>FORD Mercon LV</li>
  <li>SATURN Dex-IIIG</li>
  <li>GM Saturn 22717466</li>
  <li>GM Dex-VI [GMW 16444]</li>
  <li>SATURN T-IV Fluid</li>
  <li>GM AW-1</li>
  <li>HYUNDAI ATF SP-IV</li>
  <li>SATURN 22689186</li>
  <li>GM 19256039</li>
  <li>KIA SP-IV</li>
  <li>SSANGYONG DSIH 5M-52</li>
  <li>GM ATF WS</li>
  <li>TOYOTA ATF WS Lifetime</li>
  <li>SSANGYONG DSIH 5M-66</li>
  <li>GM 88863400</li>
  <li>MB 236.14</li>
  <li>SUBARU ATF HP</li>
  <li>GM 88863401</li>
  <li>NISSAN Matic S</li>
  <li>SUBARU ATF-WS</li>
  <li>HONDA ATF DW-1</li>
  <li>TOYOTA JWS 3324</li>
  <li>SUBARU K0140Y0700</li>
  <li>HONDA 08200-9008</li>
  <li>ATF M-1375.4</li>
  <li>SUBARU SOA635040</li>
  <li>HONDA ATF Type 3.0</li>
  <li>MB A 0019892203</li>
  <li>SUZUKI ATF 2326</li>
  <li>HONDA 08200-9016-A</li>
  <li>MB ATF 3403-M115</li>
  <li>SUZUKI ATF 2384K</li>
  <li>HONDA ATF Type 3.1</li>
  <li>MB 236.1</li>
  <li>SUZUKI ATF 3314</li>
  <li>HONDA 08200-9017</li>
  <li>MB 236.10</li>
  <li>SUZUKI ATF 3317</li>
  <li>HONDA ATF Z1</li>
  <li>MB 236.11</li>
  <li>SUZUKI ATF 5D06</li>
  <li>HONDA 08200-9001</li>
  <li>MB 236.12</li>
  <li>SUZUKI Matic D</li>
  <li>HONDA 08200-9001A</li>
  <li>MB 236.15</li>
  <li>SUZUKI Matic J</li>
  <li>HYUNDAI ATF RED-1K</li>
  <li>MB 236.2</li>
  <li>SUZUKI Matic S</li>
  <li>HYUNDAI Genuine ATF</li>
  <li>MB 236.41</li>
  <li>VOLVO 1161521</li>
  <li>HYUNDAI JWS 3314</li>
  <li>MB 236.5</li>
  <li>VOLVO 1161621</li>
  <li>HYUNDAI 00232-19023</li>
  <li>MB 236.8</li>
  <li>VOLVO 1161640</li>
  <li>HYUNDAI 040000C90SG</li>
  <li>VOLKSWAGEN LT 71141</li>
  <li>VOLVO 1161540</li>
  <li>HYUNDAI 04500-00140</li>
  <li>VOLKSWAGEN G 052 162 [AG4]</li>
  <li>VOLVO 31 256 774</li>
  <li>HYUNDAI UM040 CH20 Red-1</li>
  <li>VOLKSWAGEN G 052 533</li>
  <li>VOLVO 31 256 775</li>
  <li>HYUNDAI SP</li>
  <li>VOLKSWAGEN G 052 990 A2</li>
  <li>ZF LifeguardFluid 5 (ZF No. S671 090 170)</li>
  <li>HYUNDAI SP4-M1</li>
  <li>VOLKSWAGEN G 055 005 A2</li>
  <li>ZF LifeguardFluid 6 (ZF No. S671 090 255)</li>
  <li>HYUNDAI SPH-IV</li>
  <li>VOLKSWAGEN G 055 025 A2</li>
  <li>ZF LifeguardFluid 8 (ZF No. S671 090 312)</li>
  <li>HYUNDAI SP-II</li>
  <li>VOLKSWAGEN G 055 162 A2</li>
  <li>ZF LifeguardFluid 9 (ZF No. AA01.500.001)</li>
  <li>HYUNDAI SP-III</li>
  <li>VOLKSWAGEN G 055 540 A2</li>
  <li>ZF TE-ML 05L</li>
  <li>HYUNDAI SP-IV</li>
  <li>VOLKSWAGEN G 060 162 A2</li>
  <li>ZF TE-ML 11A</li>
  <li>HYUNDAI SP-IV-RR</li>
  <li>VOLKSWAGEN G US 000 162</li>
  <li>ZF TE-ML 11B</li>
  <li>HYUNDAI WS, spec NWS-9638</li>
  <li>BMW ATF 3+</li>
  <li>ZF TE-ML 21L</li>
  <li>KIA ATF RED-1K</li>
  <li>BMW ATF4</li>
  <li>VOLVO 97340, AT100</li>
  <li>KIA ATF SP-IV</li>
  <li>BMW ATF6</li>
  <li>VOLVO 97341, AT101</li>
  <li>KIA Genuine ATF</li>
  <li>BMW ETL-7045</li>
  <li>KIA JWS 3314</li>
  <li>BMW ETL-7045 E</li>
  <li>KIA 00232-19023</li>
  <li>MITSUBISHI ATF-J2</li>
  <li>BMW ETL-8072B</li>
  <li>MITSUBISHI ATF-J3</li>
  <li>KIA 040000C90SG</li>
  <li>BMW LA 2634</li>
  <li>KIA 04500-00140</li>
  <li>MITSUBISHI DIA Queen ATF-MA1, MZ320775</li>
  <li>BMW LT 71141</li>
  <li>MITSUBISHI Dia Queen ATF-PA, 4030401</li>
  <li>KIA SP</li>
  <li>BMW M-L12108</li>
  <li>MITSUBISHI Dia Queen AW</li>
  <li>KIA UM040 CH20 Red-1</li>
  <li>BMW 81 22 9 400 272</li>
  <li>MITSUBISHI DII</li>
  <li>KIA SP4-M1</li>
  <li>BMW 81 22 9 400 275</li>
  <li>KIA SPH-IV</li>
  <li>BMW 81 22 9 407 858</li>
  <li>MITSUBISHI SP, MS991156</li>
  <li>KIA SP-II</li>
  <li>BMW 81 22 9 407 859</li>
  <li>MITSUBISHI SP-II</li>
  <li>KIA SP-III</li>
  <li>BMW 83 22 0 024 249</li>
  <li>MITSUBISHI SP-III</li>
  <li>KIA SP-IV-RR</li>
  <li>BMW 83 22 0 024 359</li>
  <li>MITSUBISHI SP-IV</li>
  <li>KIA WS, spec NWS-9638</li>
  <li>BMW 83 22 0 026 922</li>
  <li>TOYOTA ATF FZ</li>
  <li>BMW 83 22 0 142 516</li>
  <li>TOYOTA JWS 3309</li>
  <li>BMW 83 22 0 397 114</li>
  <li>TOYOTA 08886-81015</li>
  <li>BMW 83 22 0 402 413</li>
  <li>TOYOTA Type T, T-II, T-III, T-IV</li>
  <li>BMW 83 22 0 403 248</li>
  <li>TOYOTA Type D-II</li>
  <li>BMW 83 22 0 403 249</li>
  <li>NISSAN Fluid A</li>
  <li>BMW 83 22 2 152 426</li>
  <li>NISSAN Matic D</li>
  <li>BMW 83 22 2 163 514</li>
  <li>NISSAN Matic J</li>
  <li>BMW 83 22 2 220 438</li>
  <li>NISSAN Matic K</li>
  <li>BMW 83 22 2 220 440</li>
  <li>NISSAN Matic W</li>
  <li>BMW 83 22 2 220 442</li>
  <li>NISSAN N402</li>
  <li>BMW 83 22 2 289 720</li>
  <li>NISSAN 999MP-MTJ00P, 999MP-MTS00P</li>
  <li>BMW 83 22 2 305 396</li>
  <li>ISUZU ATF II</li>
  <li>BMW 83 22 2 305 397</li>
  <li>ISUZU ATF III</li>
  <li>BMW 83 22 2 355 599</li>
  <li>ISUZU Genuine ATF</li>
  <li>BMW 83 22 2 355 601</li>
  <li>ISUZU 08200-9001</li>
  <li>BMW 83 22 7 542 290</li>
  <li>ISUZU SCS</li>
  <li>BMW 83 22 9 407 765</li>
  <li>JAGUAR 02JDE 26444</li>
  <li>BMW 83 22 9 407 807</li>
  <li>JAGUAR Fluid 8432</li>
  <li>MINI ATF JWS 3309</li>
  <li>JAGUAR JLM 20238</li>
  <li>MINI 83 22 0 402 413</li>
  <li>JAGUAR JLM 20292</li>
  <li>FORD ESP-M2C138-CJ</li>
  <li>JAGUAR JLM 21044</li>
  <li>FORD ESP-M2C166-H</li>
  <li>JAGUAR K17, Jatco 3100 PL085</li>
  <li>FORD XT-10-QLV [LV]</li>
  <li>JAGUAR LT 71141</li>
  <li>FORD XT-2-QDX [M]</li>
  <li>JAGUAR WSS-M2C922-A1</li>
  <li>FORD XT-2-QSM [Syn]</li>
  <li>LAND ROVER ATF N402</li>
  <li>FORD XT-5-QM [V]</li>
  <li>LAND ROVER AW-1, LR0022460: LV</li>
  <li>FORD XT-5-QSM [V Syn]</li>
  <li>LAND ROVER JWS3309US</li>
  <li>FORD XT-6-QSP [SP]</li>
  <li>LAND ROVER TYK500050</li>
  <li>FORD XT-8-QAW [Premium]</li>
  <li>LAND ROVER LR023288/LR023289</li>
  <li>FORD XT-9-QMM5 [FRN5]</li>
  <li>MAN 339A</li>
  <li>FORD WSS-M2C922-A1</li>
  <li>MAN 339D</li>
  <li>ALLISON C3</li>
  <li>MAN 339F</li>
  <li>ALLISON C2</li>
  <li>MASERATI Oil No. 231603</li>
  <li>MAZDA ATF FZ, ATF N-1, ATF S-1</li>
  <li>AISIN WARNER JWS 3309</li>
  <li>MAZDA ATF M-5, 0000-23-ATF-M5</li>
  <li>AISIN WARNER JWS 3324</li>
  <li>MAZDA F-1</li>
  <li>AISIN WARNER ATF-0T4</li>
  <li>MAZDA JWS3317</li>
  <li>AISIN WARNER ATF-0WS</li>
  <li>MAZDA M3</li>
  <li>BENTLEY PY112995PA</li>
  <li>MAZDA Type T-IV, JWS 3309</li>
  <li>BOSCH TE-ML 09</li>
  <li>PEUGEOT Z 000169756</li>
  <li>CITROEN Z 000169756</li>
  <li>PORSCHE JWS 3309</li>
  <li>FCA ATF+3</li>
  <li>PORSCHE 000 043 205 28</li>
  <li>FCA ATF+2</li>
  <li>PORSCHE LT 71141</li>
  <li>FCA ATF+</li>
  <li>PORSCHE 000 043 204 63</li>
  <li>FCA ASRC</li>
  <li>PORSCHE 000 043 304 00</li>
  <li>FCA 8 &amp; 9 Speed ATF</li>
  <li>PORSCHE 999 917 547 00 (A2)</li>
  <li>FCA 68218925AA</li>
  <li>PORSCHE 000 043 205 09</li>
  <li>FCA 68218925AB</li>
  <li>PSA AL4 / 4HP20</li>
  <li>FCA AW-1</li>
  <li>PSA 9730AE</li>
  <li>FCA 68092912AA</li>
  <li>PSA B71 2340</li>
  <li>FCA 68043742AA</li>
  <li>RENAULT DP-0</li>
  <li>FCA Dex-VI</li>
  <li>RENAULT Matic D2</li>
  <li>FCA 05127382AA</li>
  <li>RENAULT SATF-D</li>
  <li>FCA 05127382</li>
  <li>ROLLS_ROYCE Oil No. PL 31493PA</li>
  <li>FCA 68157995AA</li>
  <li>FCA 68157995AB</li>
  <li>FCA 68333587AA</li>
  <li>FCA SP-IV</li>
  <li>FCA SP-III</li>
  <li>FCA 68171869AA</li>
  <li>FCA Type 7176E</li>
  <li>FCA Type 9602</li>
  <li>ATF M-1375.6</li>
  <li>ATF LA 2634</li>
  <li>ATF L12108</li>
  <li>ATF ETL-7045 E</li>
  <li>ATF 3403-M115</li>
  <li>ATF 3100 PL085</li>
  <li>ATF 3353</li>
  <li>ATF 134</li>
  <li>ATF K17</li>
  <li>ATF N402</li>
  <li>DAIHATSU D3-SP</li>
  <li>GM Dex [GM 6032M]</li>
  <li>GM Dex-B [GM 6032M]</li>
  <li>GM Dex-IIC [6137M]</li>
  <li>GM Dex-IID [GM 6137M]</li>
  <li>GM Dex-IIE [GM 6137M]</li>
  <li>GM Dex-IIIF [GM 6297M]</li>
  <li>GM Dex-IIIG [GM 6417M]</li>
  <li>GM Dex-IIIH [GM N10055]</li>
  <li>GM 19 40 700</li>
  <li>GM 19 40 767</li>
  <li>GM 21005966</li>
  <li>GM 88900925</li>
  <li>GM 9985010</li>
  <li>GM 9986195</li>
</ul>
          
          </div>

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF8615-1)
                </span>
              </li>

              {/* <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6201-60)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L (FF6201-DR)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6201-IBC)
                </span>
              </li> */}

            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href="https://www.fanfaro.de/create-pdf/85"
                  target="_blank"
                  style={{ textDecoration: "none" }}>
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>



      </div>

      {/* MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

      {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>FANFARO M-4T Plus</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
   </>
  );
}